export const blurParam = `blur=2000`;
